import * as React from 'react';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import CustomTable from '../../components/atoms/Table'
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box, Button, IconButton, Grid, MenuItem, Select, Modal, Paper, Rating, Switch, Typography, LinearProgress, Card, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { CustomSelect } from '../../components/atoms';
import service from '../../api/services';
import { endOfMonth, endOfWeek, startOfMonth, startOfWeek } from 'date-fns';
import SoftTypography from 'components/SoftTypography';
import SoftBox from 'components/SoftBox';
import SoftButton from 'components/SoftButton';
import DatePicker from 'react-flatpickr';
import SoftInput from 'components/SoftInput';
import ThumbsUpIcon from "@mui/icons-material/ThumbUp";
import ThumbsDownIcon from "@mui/icons-material/ThumbDown";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import {
    Chart as ChartJS,
    BarElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import GradientLineChart from "examples/Charts/BarCharts/VerticalBarChart copy 2";
import { ArrowDownward } from '@mui/icons-material';
// import { getLocationData } from 'api/commonSlice';
import { useDispatch, useSelector } from 'react-redux';
import ApnaSelect from 'components/ApnaSelect';
import { useAuth } from 'AuthContext';
const categories = [{ name: 'This Month' }, { name: 'This Week' }, { name: 'Custom Date' }];
// Columns configuration
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    minWidth: 400,
    bgcolor: 'background.paper',
    borderRadius: 2,
    boxShadow: 24,
    p: 4,
};
ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);


const reviewOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
        y: {
            beginAtZero: true,
            max: 100,
            ticks: {
                callback: (value) => `${value}%`,
            },
        },
    },
    plugins: {
        legend: {
            display: false,
        },
        tooltip: {
            callbacks: {
                label: (context) => `${context.parsed.y}%`,
            },
        },
    },
};


const Review = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [isApiLoading, setIsApiLoading] = React.useState(true)
    const detailsRef = React.useRef(null);
    const current = new Date().toISOString().split('T')[0]; // Today's date in YYYY-MM-DD format
    const next5years = new Date();
    next5years.setFullYear(next5years.getFullYear() + 5);
    const [selectedLocation, setSelectedLocation] = React.useState("default");
    const [allLocations, setAllLocations] = React.useState([]);
    const locations = useSelector((state) => state.commonSlice?.locations);
    const next5YearsDate = next5years.toISOString().split('T')[0]; // 5 years from today
    const [data, setData] = React.useState([]);
    const [search, setSearch] = React.useState('');
    const [page, setPage] = React.useState(1);
    const [startDate, setStartDate] = React.useState(null);
    const [modalStartDate, setModalStartDate] = React.useState(null);
    const [modalEndDate, setModalEndDate] = React.useState(null);
    const [endDate, setEndDate] = React.useState(null);
    const [open, setOpen] = React.useState(false);
    const [showDetail, setShowDetail] = React.useState(false);
    const [categoryData, setCategoryData] = React.useState([]);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [reviewTagBar, setReviewTagBar] = React.useState(null);
    const [selectedRowID, setSelectedRowID] = React.useState('')
    const [selectedTitle, setSelectedTitle] = React.useState(null)
    const [selectedIndex, setSelectedIndex] = React.useState(null)
    const [sortValue, setSortValue] = React.useState({ sortKey: 'name', sortDirection: 'asc' });
    const [thumb, setThumb] = React.useState('thumbs_up')
    const [ratingDetail, setRatingDetail] = React.useState({
        labels: [],
        datasets: [
            {
                label: "Reviews Rating %",
                color: "info",
                data: [],
            },
        ],
    });
    const [isLoading, setIsLoading] = React.useState(false);
    // const reviewData = {
    //     labels: ratingDetail ? ratingDetail?.map((item) => item.name) : [],
    //     datasets: [
    //         {
    //             label: 'Reviewee answer',
    //             data: ratingDetail ? ratingDetail?.map((item) => item.value) : [],
    //             backgroundColor: '#1E90FF',
    //             borderRadius: 8,
    //         },
    //     ],
    // };

    const columns = [
        {
            id: 'business', label: 'Business', isSorting: true, sortDirection: 'asc',
            render: (row) => (
                <>
                    {row?.businessName}
                </>

            )
        },
        {
            id: 'averageRating',
            label: 'Avg. Star Rating',
            render: (row) => (

                <div>

                    <Rating name="read-only" value={row.averageRating} readOnly />

                </div>
            )

        },
        { id: 'totalReviews', label: 'Total Reviews', isSorting: true, sortDirection: 'asc', },

        {
            id: 'details',
            label: 'Details',
            render: (row, index) => (
                <SoftButton variant={`${(index === selectedIndex) && showDetail ? 'outlined' : 'gradient'}`} color="info"
                    sx={{ textTransform: 'none' }}
                    onClick={() => {
                        if ((index === selectedIndex) && showDetail) {
                            setShowDetail(false);
                            setSelectedIndex(null)
                            return;
                        }
                        setSelectedIndex(index)
                        setSelectedTitle(row.businessName);
                        setSelectedRowID(row.businessId);
                        getViewDetail(row.businessId);
                        fetchAllLocations(row.businessUserId)
                    }}
                >
                    View details
                </SoftButton>
            )
        }
    ];

    const handleCategoryChange = (e) => {
        const selected = e.target.value;

        const today = new Date();

        if (selected === 'This Month') {
            setStartDate(startOfMonth(today));
            setEndDate(endOfMonth(today));
        } else if (selected === 'This Week') {
            setStartDate(startOfWeek(today, { weekStartsOn: 1 })); // Monday as start
            setEndDate(endOfWeek(today, { weekStartsOn: 1 }));
        } else if (selected === 'Custom Date') {
            setStartDate(null);
            setEndDate(null);
            setOpen(true)
        }
    };

    const getUserDetail = async () => {
        try {
            const response = await service.bussinessReviews.view(localStorage.getItem('id'), { startDate, endDate, searchData: search, page, limit: rowsPerPage, sortKey: sortValue.sortKey, sortDirection: sortValue.sortDirection });
            if (response?.data?.data) {
                setData(response.data);
            }
        } catch (error) {
            console.error("Failed to fetch business users", error);
        }
        setIsApiLoading(false)
    };

    React.useEffect(() => {
        getUserDetail();
    }, [search, page, rowsPerPage, endDate, sortValue])

    const handleApply = async () => {
        try {
            const response = await service.bussinessReviews.view(localStorage.getItem('id'), { startDate: modalStartDate, endDate: modalEndDate, searchData: search, page, limit: rowsPerPage });
            if (response?.data?.data) {
                setData(response.data);
                setOpen(false);
                setModalEndDate(null)
                setModalStartDate(null)
            }

        } catch (error) {
            console.error("Failed to fetch business users", error);
        }
    };

    const getViewDetail = async (id, customType,locationType) => {

        setIsLoading(true);
        const current = new Date().toISOString().split('T')[0];
        const next5years = new Date();
        next5years.setFullYear(next5years.getFullYear() + 5);
        const next5YearsDate = next5years.toISOString().split('T')[0];

        try {
            const reviewTagRes = await service.bussinessReviews.reviewTagBar(id, {
                startDate: null,
                endDate: null,
                businessId: locationType || selectedLocation,
                type: customType ? customType : thumb
            });

            const ratingDetailRes = await service.bussinessReviews.ratingDetail(id, {
                startDate: null,
                endDate: null,
                businessId: locationType || selectedLocation
            });

            const labels = reviewTagRes?.data?.data?.map((item) => item?.name);
            const values = reviewTagRes?.data?.data?.map((item) => item?.value);

            setRatingDetail({
                labels: labels,
                datasets: [
                    {
                        label: "Percentage %",
                        color: "info",
                        data: values,
                    },
                ],
            });
            console.log("reviewTagRes.data.data", ratingDetailRes.data.data);

            setReviewTagBar(ratingDetailRes.data.data);
            setShowDetail(true);
            // Scroll after data is loaded
            setTimeout(() => {
                detailsRef.current?.scrollIntoView({ behavior: 'smooth' });
            }, 200);
        } catch (error) {
            console.error("Failed to fetch business review details:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchAllLocations = async (id) => {
        if (!id) return;

        try {
            const response = await service.bussinessReviews.getLocation(id, { limit: 20, page: 1, businessId: 'default', status: 'all' })
            if (response?.data) {
                setAllLocations([]);
                response?.data?.data &&
                    response?.data?.data?.length > 0 &&
                    response?.data?.data?.map((location) => {
                        setAllLocations((prev) => [...prev, { _id: location?._id, name: location?.locationName }]);
                    })
            }
        } catch (err) {

            console.log(err)

        }
    };
   


    const handleLocationChange = (event) => {
        setSelectedLocation(event.target.value);
        getViewDetail(selectedRowID, thumb,event.target.value);
    };

    const handleFilterChange = (event) => {
        setThumb(event.target.value);
        getViewDetail(selectedRowID, event.target.value,selectedLocation);
    };
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <Paper className='glassmorphism-card' sx={{ padding: 2, mt: '15px' }}>
                <Box display="flex" alignItems="center" justifyContent={'end'}>
                    <CustomSelect
                        name="category"
                        options={categories}
                        className={'remove-light-color'}
                        onChange={handleCategoryChange}
                    >
                    </CustomSelect>
                </Box>
                <CustomTable
                    title="Bussiness" columns={columns} rows={data?.data || []}
                    search={search}
                    setSearch={setSearch}
                    page={page}
                    setPage={setPage}
                    rowsPerPage={rowsPerPage}
                    isApiLoading={isApiLoading}
                    setRowsPerPage={setRowsPerPage}
                    totalPages={data?.pagination?.totalItems}
                    onRequestSort={(id, direction) => {
                        setSortValue({ sortKey: id, sortDirection: direction })

                    }}
                />
            </Paper>

            <Box pt={4} ref={detailsRef}>
                {showDetail && (
                    <Grid container spacing={4}>
                        <Grid item xs={12}>
                            <SoftTypography variant="h4" fontWeight="bold" textAlign="center" mb={1}>
                                {selectedTitle}
                            </SoftTypography>
                        </Grid>
                        {isLoading ? (
                            <Grid item xs={12}>
                                <SoftBox display="flex" justifyContent="center" alignItems="center" minHeight="400px">
                                    <CircularProgress />
                                </SoftBox>
                            </Grid>
                        ) : (
                            <>
                                {/* Left Side */}
                                <Grid item xs={12} md={4}>
                                    <SoftBox mb={2}>
                                        <SoftTypography variant="h6">Filters </SoftTypography>
                                        <SoftBox
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                            }}
                                        >
                                            <SoftBox mr={2}>
                                                <ApnaSelect
                                                    origin="Location"
                                                    value={selectedLocation}
                                                    options={allLocations}
                                                    isCustomHeader={'All'}
                                                    customValue={'default'}
                                                    onChange={handleLocationChange}
                                                />
                                            </SoftBox>
                                        </SoftBox>
                                    </SoftBox>
                                    {reviewTagBar && (
                                        <SoftBox
                                            className='glassmorphism-card'
                                        >
                                            {/* Positive Review */}
                                            <SoftBox display="flex" alignItems="center" p={2} justifyContent="space-between">
                                                <Card className="glassmorphism-card">
                                                    <SoftBox py={3} px={2} m={0.5}>
                                                        <SoftBox sx={{ display: "flex", alignItems: 'center' }}>
                                                            <IconButton>
                                                                <ThumbsUpIcon sx={{ color: "#4caf50" }} />
                                                            </IconButton>
                                                            <ArrowUpwardIcon color="success" />
                                                            <SoftTypography variant="h6" color="success">
                                                                {(reviewTagBar?.Thumbs_Up_Percentage || 0) + "% "}
                                                            </SoftTypography>{" "}
                                                        </SoftBox>
                                                        <SoftTypography variant="h6" >
                                                            Positive Review ({reviewTagBar?.Thumbs_Up_Percentage})
                                                        </SoftTypography>
                                                        <SoftTypography variant="caption" sx={{ display: "flex", alignItems: 'center' }}>
                                                            {('N/A')}
                                                        </SoftTypography>
                                                    </SoftBox>
                                                </Card>
                                                <Card className="glassmorphism-card">
                                                    <SoftBox py={3} px={2} m={0.5}>
                                                        <SoftBox sx={{ display: "flex", alignItems: "center" }}>
                                                            <IconButton>
                                                                <ThumbsDownIcon sx={{ color: "#f44336" }} />
                                                            </IconButton>
                                                            <ArrowDownward color="error" /><SoftTypography variant="h6" color="error">{(reviewTagBar?.Thumbs_Down_Percentage || 0)}</SoftTypography>  {" "}
                                                        </SoftBox>
                                                        <SoftTypography variant="h6" >
                                                            Negative Review ({reviewTagBar?.Thumbs_Down_Percentage})
                                                        </SoftTypography>
                                                        <SoftTypography variant="caption" sx={{ display: "flex", alignItems: "center" }}>
                                                            {'N/A'}
                                                        </SoftTypography>
                                                    </SoftBox>
                                                </Card>
                                            </SoftBox>



                                            {/* Divider */}
                                            <Box
                                                sx={{
                                                    borderBottom: '1px solid #ddd',
                                                    my: 2,
                                                }}
                                            />

                                            {/* Reviews Histogram */}
                                            <SoftTypography variant="subtitle2" fontWeight="bold" pl={2} gutterBottom>
                                                Ratings Overview
                                            </SoftTypography>

                                            <SoftBox pl={2} pr={2}>
                                                {Object.keys(reviewTagBar).map((star) => {
                                                    const percentKey = ['Five_Star_Percentage', 'Four_Star_Percentage', 'Three_Star_Percentage', 'Two_Star_Percentage', 'One_Star_Percentage'];
                                                    if (!percentKey.includes(star)) {
                                                        return
                                                    }
                                                    const percentage = reviewTagBar[star] ?? 0;

                                                    return (
                                                        <SoftBox key={star} display="flex" alignItems="center" mb={1}>
                                                            <SoftTypography width={32} fontWeight="medium">
                                                                {(() => {
                                                                    switch (star) {
                                                                        case 'Five_Star_Percentage': return '5.0';
                                                                        case 'Four_Star_Percentage': return '4.0';
                                                                        case 'Three_Star_Percentage': return '3.0';
                                                                        case 'Two_Star_Percentage': return '2.0';
                                                                        default: return '1.0';
                                                                    }
                                                                })()}
                                                            </SoftTypography>

                                                            <Box sx={{ width: `${percentage}%`, ml: 2 }}>
                                                                <LinearProgress
                                                                    variant="determinate"
                                                                    value={percentage}
                                                                    sx={{
                                                                        height: 8,
                                                                        borderRadius: 5,
                                                                        backgroundColor: '#e0e0e0',
                                                                        '& .MuiLinearProgress-bar': {
                                                                            backgroundColor: '#2196f3',
                                                                        },
                                                                    }}
                                                                />
                                                            </Box>
                                                        </SoftBox>

                                                    );
                                                })}
                                            </SoftBox>
                                        </SoftBox>
                                    )}
                                </Grid>


                                {/* Right Side - Chart */}

                                <Grid item xs={12} lg={8}>
                                    <GradientLineChart
                                        title={`Response `}
                                        description={
                                            'Review answer'
                                        }
                                        height="25.3rem"
                                        chart={ratingDetail}
                                        option={[{ name: "Thumbs Up", _id: 'thumbs_up' }, { name: "Thumbs Down", _id: 'thumbs_down' }]}
                                        handleFilterChange={handleFilterChange}
                                        selectedFilter={thumb}
                                    />
                                </Grid>
                            </>
                        )}
                    </Grid>
                )}
            </Box>



            <Modal open={open} onClose={() => setOpen(false)}>
                <SoftBox sx={style}>
                    <SoftTypography variant="h6" mb={3} sx={{ color: '#6c757d' }}>
                        Set a Schedule
                    </SoftTypography>

                    <SoftBox display="flex" gap={2} mb={3}>
                        <SoftBox flex={1}>
                            <SoftTypography variant="body2" mb={1}>
                                From:
                            </SoftTypography>
                            <SoftInput
                                type="date"
                                fullWidth
                                value={modalStartDate || ''}
                                onChange={(e) => setModalStartDate(e.target.value)}
                            />
                        </SoftBox>

                        <SoftBox flex={1}>
                            <SoftTypography variant="body2" mb={1}>
                                To:
                            </SoftTypography>
                            <SoftInput
                                type="date"
                                fullWidth
                                value={modalEndDate || ''}
                                onChange={(e) => setModalEndDate(e.target.value)}
                            />
                        </SoftBox>
                    </SoftBox>
                    <SoftBox display="flex" justifyContent="flex-end" gap={2}>
                        <SoftButton

                            variant="outlined"
                            color="info"
                            onClick={() => setOpen(false)}
                        >
                            Cancel
                        </SoftButton>
                        <SoftButton variant="gradient" color="info"
                            onClick={handleApply}
                            sx={{ bgcolor: '#007bff', '&:hover': { bgcolor: '#0056b3' } }}
                        >
                            Apply
                        </SoftButton>
                        {/* <Button onClick={() => setOpen(false)}>Cancel</Button> */}

                    </SoftBox>
                </SoftBox>
            </Modal>


        </DashboardLayout>
    );
}

export default Review
